// Port of api/fuel/app/classes/filter/search/games/filters/query/other/publishers.php
import DB from 'offline/db'
import Util from 'offline/util'
import F from 'offline/filter/constants'
export default {
	name: 'other.publishers',
	priority: 71,
	require: function(config, filter) {
		return filter.publishers && filter.publishers.length > 0
	},
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.publishers.length; i++) {
			var d = filter.publishers[i]
			if (d < 0) exclude.push(-d)
			else include.push(d)
		}

		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT game_id AS g FROM game_publisher WHERE publisher_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}

		if (include.length) {
			// Game-level publishers: primary=1, version_id=0
			var gameRows = DB.query(
				'SELECT DISTINCT game_id AS g FROM game_publisher WHERE publisher_id IN(' + Util.in(include) + ')' +
				' AND game_publisher_primary = 1 AND game_version_id = 0'
			)
			var gameIds = Util.pluck(gameRows, 'g')
			if (!gameIds.length) gameIds = [0]

			if (filter.source && filter.source.all) {
				query.where('g.game_id', 'in', gameIds)
			} else {
				// Version-level publishers: primary=1, version_id > 0
				var versionRows = DB.query(
					'SELECT DISTINCT game_version_id AS v FROM game_publisher WHERE publisher_id IN(' + Util.in(include) + ')' +
					' AND game_publisher_primary = 1 AND game_version_id > 0'
				)
				var versionIds = Util.pluck(versionRows, 'v')
				if (!versionIds.length) versionIds = [-1]

				query.whereGroup('OR', [
					['AND', [
						['c.game_version_id', 'in', versionIds]
					]],
					['AND', [
						['c.game_id', 'in', gameIds],
						['c.game_version_id', '=', 0]
					]]
				])
			}
		}
	}
}
